import React from "react";
import * as Yup from "yup";

import {
  useWSSnackbar,
  WSActions,
  WSForm,
  WSInfoBox,
  WSInputTextarea,
  WSList
} from "@wingspanhq/fe-component-library";

import { ErrorAlert } from "@components/ErrorAlert";
import { queriesPayees } from "@query";
import { useXWingspanPayerId } from "../../routes/RoutePayeeDetails/useXWingspanPayerId";

// The form writes exactly one v3 field, so it is typed on that rather than on
// the old v1 `IPayeeUpdateRequest["payerOwnedData"]` envelope.
type FormData = { internalNotes?: string };

type Props = {
  payeeId: string;
  internalNotes?: string;
  onClose: () => void;
};

export const InternalNotesModal: React.FC<Props> = ({
  payeeId,
  internalNotes,
  onClose
}) => {
  const { openSnackbar } = useWSSnackbar();
  const xWingspanAccount = useXWingspanPayerId();
  const [updatePayee, updatePayeeMeta] =
    queriesPayees.updatePayee.useMutation();
  const onSubmit = async (data: FormData) => {
    await updatePayee(
      {
        payeeId,
        payeeUpdate: {
          internalNotes: data.internalNotes
        },
        xWingspanAccount
      },
      {
        onSuccess: () => {
          openSnackbar({
            message: "Internal notes updated successfully",
            type: "success"
          });
          onClose();
        }
      }
    );
  };
  return (
    <>
      <WSForm<FormData>
        defaultValues={{
          internalNotes: internalNotes || ""
        }}
        validationSchema={Yup.object().shape({
          internalNotes: Yup.string()
            .required("Required")
            .max(2000, "Max 2000 characters allowed")
        })}
        onSubmit={onSubmit}
      >
        <WSList gap="XL">
          <WSForm.Field
            name="internalNotes"
            label="Notes"
            component={WSInputTextarea}
            componentProps={{
              required: true
            }}
          />

          <WSInfoBox>
            The internal note is visible to you and your team only.
          </WSInfoBox>

          <ErrorAlert
            context="EditPayerPayeeInternalNotes"
            error={updatePayeeMeta.error}
          />

          <WSActions
            buttons={[
              {
                label: "Cancel",
                onClick: onClose,
                kind: "Tertiary",
                fullWidth: true
              },
              {
                label: "Save changes",
                type: "submit",
                fullWidth: true,
                loading: updatePayeeMeta.isLoading
              }
            ]}
          />
        </WSList>
      </WSForm>
    </>
  );
};
